<script>
/**
 * Descripción: Input reutilizable
 *
 * @displayName BaseInput
 */

import { mask } from 'vue-the-mask';

import BaseLocalHelper from '@/helpers/BaseLocalHelper';

export default {
  name: 'BaseInput',

  directives: { mask },

  inheritAttrs: false,

  props: {
    /**
     * append-icon
     * No Requerido
     */
    appendIcon: {
      type: String,
      default: undefined
    },

    /**
     * prepend-inner-icon
     * No Requerido
     */
    prependInnerIcon: {
      type: String,
      default: undefined
    },

    /**
     * Inhabilitar input
     * Default false
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Label del input
     * Requerido
     */
    label: {
      type: String,
      default: undefined
    },

    /**
     * prepend-icon
     * No Requerido
     */
    prependIcon: {
      type: String,
      default: undefined
    },

    /**
     * Estado de solo lectura
     * Default false
     */
    readonly: {
      type: Boolean,
      default: false
    },

    /**
     * Tipo de input
     * Default text
     */
    type: {
      type: String,
      default: 'text'
    },

    /**
     * V-model
     */
    value: {
      type: [String, Number]
    },

    /**
     * Lista de errores
     * No es requerido
     */
    errors: {
      type: String,
      default: null
    },

    /**
     * Como validar el input
     * ['text'] ['email'] [ @validacionPersonalizada ]
     */
    validate: {
      type: Array,
      required: false
    },

    /**
     * Caracteres max
     * Default: 100
     */
    max: {
      type: Number,
      default: 100
    },

    /**
     * Caracteres min
     * Default: 0
     */
    min: {
      type: Number,
      default: 0
    },

    /**
     * Función
     */
    click: {
      type: Function,
      default: undefined
    },

    /**
     * Función icon
     */
    clickAppend: {
      type: Function,
      default: undefined
    },

    /**
     * Función icon
     */
    clickAppendOuter: {
      type: Function,
      default: undefined
    },

    /**
     * Función icon
     */
    clickPrependInner: {
      type: Function,
      default: undefined
    },

    /**
     * Mask Input
     */
    mask: {
      default: undefined
    },

    /**
     * Contador de caracteres del input
     */
    counter: {
      type: Number,
      default: undefined
    },

    /**
     * Función change
     */
    change: {
      type: Function,
      default: undefined
    }
  },

  data() {
    return {
      normalRules: [],
      BoolMask: false
    };
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.$_updateValue
      };
    }
  },

  /**
   * Validaciones
   */
  created() {
    this.$props.mask != undefined
      ? (this.BoolMask = true)
      : (this.BoolMask = false);

    if (this.validate != undefined) {
      switch (this.validate[0]) {
        case 'text':
          this.normalRules = [
            v =>
              !!v ||
              BaseLocalHelper.$_MsgFieldRequired(
                this.label != undefined ? this.label : ''
              ),
            v =>
              (v && v.length <= this.max) ||
              BaseLocalHelper.$_MsgFieldMaxlengthInvalid(
                this.label != undefined ? this.label : '',
                this.max
              )
          ];
          break;

        case 'number':
          this.normalRules = [
            v =>
              !!v ||
              BaseLocalHelper.$_MsgFieldRequired(
                this.label != undefined ? this.label : ''
              ),
            v =>
              /^\d{1,15}(\.)?\d{0,5}$/.test(v) ||
              BaseLocalHelper.$_MsgFieldAllowedValueInvalid(
                this.label != undefined ? this.label : ''
              )
          ];
          break;

        case 'email':
          this.normalRules = [
            v =>
              !!v ||
              BaseLocalHelper.$_MsgFieldRequired(
                this.label != undefined ? this.label : ''
              ),
            v =>
              /.+@.+\..+/.test(v) ||
              BaseLocalHelper.$_MsgFieldAllowedValueInvalid(
                this.label != undefined ? this.label : ''
              )
          ];
          break;

        case 'DNI':
          this.normalRules = [
            v =>
              !!v ||
              BaseLocalHelper.$_MsgFieldRequired(
                this.label != undefined ? this.label : ''
              ),

            v =>
              /^[1-9][0-9-]+$/.test(v) ||
              BaseLocalHelper.$_MsgFieldAllowedValueInvalid(
                this.label != undefined ? this.label : ''
              ),

            v =>
              (v && v.length <= this.max && v && v.length >= this.min) ||
              BaseLocalHelper.$_MsgFieldAllowedExtInvalid(
                this.label != undefined ? this.label : ''
              )
          ];
          break;

        default:
          this.normalRules = this.validate;
      }
    }
  },

  /**
   * Metodos click icon
   */
  methods: {
    $_updateValue(event) {
      this.$emit('input', event);
    },

    $_onClick() {
      if (this.click != undefined) {
        this.click();
      }
    },

    $_append() {
      if (this.clickAppend != undefined) {
        this.clickAppend();
      }
    },

    $_appendOuter() {
      if (this.clickAppendOuter != undefined) {
        this.clickAppendOuter();
      }
    },

    $_prependInner() {
      if (this.clickPrependInner != undefined) {
        this.clickPrependInner();
      }
    },

    $_change() {
      if (this.change != undefined) {
        this.change();
      }
    }
  }
};
</script>

<template>
  <div>
    <div v-if="BoolMask">
      <v-text-field
        :append-icon="appendIcon"
        :disabled="disabled"
        :error-messages="errors"
        :label="label"
        :prepend-icon="prependIcon"
        :prepend-inner-icon="prependInnerIcon"
        :readonly="readonly"
        :type="type"
        :rules="normalRules"
        @click:append="$_append"
        @click="$_onClick"
        @click:append-outer="$_appendOuter"
        @click:prepend-inner="$_prependInner"
        :value="value"
        @input="$_updateValue"
        v-bind="$attrs"
        v-on="listeners"
        v-mask="mask"
        masked="false"
        :counter="counter"
        @change="$_change"
      ></v-text-field>
    </div>

    <div v-else>
      <v-text-field
        :append-icon="appendIcon"
        :disabled="disabled"
        :error-messages="errors"
        :label="label"
        :prepend-icon="prependIcon"
        :prepend-inner-icon="prependInnerIcon"
        :readonly="readonly"
        :type="type"
        :rules="normalRules"
        @click:append="$_append"
        @click="$_onClick"
        @click:append-outer="$_appendOuter"
        @click:prepend-inner="$_prependInner"
        :value="value"
        @input="$_updateValue"
        v-bind="$attrs"
        v-on="listeners"
        :counter="counter"
        @change="$_change"
      ></v-text-field>
    </div>
  </div>
</template>
